import { Link } from 'react-router-dom';

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  moreTo?: string;
  moreLabel?: string;
  icon?: string;
}

export default function SectionHeading({
  title,
  subtitle,
  moreTo,
  moreLabel = '查看更多',
  icon,
}: SectionHeadingProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-5 md:mb-6">
      <div>
        <h2 className="font-heading font-extrabold text-xl md:text-2xl text-foreground-950 flex items-center gap-2">
          {icon && (
            <span className="w-8 h-8 md:w-9 md:h-9 flex items-center justify-center rounded-md bg-primary-100 text-primary-600 text-lg">
              <i className={icon}></i>
            </span>
          )}
          {title}
        </h2>
        {subtitle && <p className="mt-1.5 text-sm text-foreground-500">{subtitle}</p>}
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="shrink-0 inline-flex items-center gap-1 text-sm font-medium text-accent-600 hover:text-accent-700 transition-colors whitespace-nowrap"
        >
          {moreLabel}
          <i className="ri-arrow-right-s-line"></i>
        </Link>
      )}
    </div>
  );
}